Core.RemoteSignatureRouter = Core.SubRouter.extend({
    routes: {
        'new': 'createRemoteSignature',
        ':id': 'viewRemoteSignature',
    },

    viewRemoteSignature: function(id) {
        debug.log('view remote signature', id);
        var view = new RemoteSignatureView({ id: id });
        view.setModel(new Core.RemoteSignature({ id: id }))
        app.setMainView(view);
    },
    
    createRemoteSignature: function() {
        debug.log('create remote signature');
        var view = new CreateRemoteSignatureView();
        view.setModel(new Job({id: Core.param('jobId')}));
        app.setMainView(view);
    }
})